package navigation.settings.areas

import navigation.settings.areas.addeditarea.AddEditAreaScreenModel
import navigation.settings.areas.allareas.AllAreasScreenModel
import org.koin.core.module.dsl.factoryOf
import org.koin.dsl.module

val areaUiModule
    get() =
        module {
            factoryOf(::AllAreasScreenModel)
            factoryOf(::AddEditAreaScreenModel)
        }